/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncTargetsToCalculationSettingsResult
 */
export interface SyncTargetsToCalculationSettingsResult {
    /**
     * 
     * @type {number}
     * @memberof SyncTargetsToCalculationSettingsResult
     */
    updatedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SyncTargetsToCalculationSettingsResult
     */
    skippedCount?: number;
}

/**
 * Check if a given object implements the SyncTargetsToCalculationSettingsResult interface.
 */
export function instanceOfSyncTargetsToCalculationSettingsResult(value: object): value is SyncTargetsToCalculationSettingsResult {
    return true;
}

export function SyncTargetsToCalculationSettingsResultFromJSON(json: any): SyncTargetsToCalculationSettingsResult {
    return SyncTargetsToCalculationSettingsResultFromJSONTyped(json, false);
}

export function SyncTargetsToCalculationSettingsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncTargetsToCalculationSettingsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedCount': json['updatedCount'] == null ? undefined : json['updatedCount'],
        'skippedCount': json['skippedCount'] == null ? undefined : json['skippedCount'],
    };
}

export function SyncTargetsToCalculationSettingsResultToJSON(json: any): SyncTargetsToCalculationSettingsResult {
    return SyncTargetsToCalculationSettingsResultToJSONTyped(json, false);
}

export function SyncTargetsToCalculationSettingsResultToJSONTyped(value?: SyncTargetsToCalculationSettingsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedCount': value['updatedCount'],
        'skippedCount': value['skippedCount'],
    };
}

